import { Logger } from "../../Logger";
export class NoTrackError {
    name = "NoTrackError";
    message = "No track of the expected kind was found";
}
export const setContentHint = (track, hint) => {
    if (!track)
        return;
    track.contentHint = hint;
    if (track.contentHint !== hint) {
        Logger.warn("tried to set invalid content hint", hint);
    }
};
export const guaranteedGetUserMediaException = (error) => {
    if (error instanceof DOMException)
        return error;
    if (window.OverconstrainedError && error instanceof OverconstrainedError)
        return error;
    throw error;
};
//# sourceMappingURL=utils.js.map